/**
 * @author yan st
 * @date 2025-10-09 13:49
 * @Description:
 */
import {qspost, get, upload} from '@/plugins/axios'

/*
* 人员列表
* */
export const login = (username,pwd,type) => qspost('/api/login', {
  username,pwd,type
})

/*
* 获取 机构信息 - 基础信息
* */
export const get_base_info = () => get('/api/org/get_base_info', {

})

/*
* 机构信息 - 基础信息 - 上半部分
* */
export const save_base = (
  zancun,logo,use_address,floor,lease_contract_start,lease_contract_end,lease_contract,area,build_date,apprenticeship_contract,
  apprenticeship_contract_files,contract_use_model,institutional_situation,chengnuoshu
) => qspost('/api/org/save_base', {
  zancun,logo,use_address,floor,lease_contract_start,lease_contract_end,lease_contract,area,build_date,apprenticeship_contract,
  apprenticeship_contract_files,contract_use_model,institutional_situation,chengnuoshu
})

/*
* 机构信息 - 基础信息 - 下半部分
* */
export const save_check = (
  zancun,org_name,change_file,zhuce_ziben,shijiao_ziben, is_faren_banxue,brand,have_group, group,is_reg,is_license_able,
  xuke_no,xuke_zhucedi,xuke_con,xuke_set_date,xuke_date,
  fire_safes,is_stock_org,org_code,reg_address
) => qspost('/api/org/save_check', {
  zancun,org_name,change_file,zhuce_ziben,shijiao_ziben, is_faren_banxue,brand,have_group, group,is_reg,is_license_able,
  xuke_no,xuke_zhucedi,xuke_con,xuke_set_date,xuke_date,
  fire_safes,is_stock_org,org_code,reg_address
})

/*
* 保存 资金监管信息
* */
export const save_zijin = (
  zancun,is_kaili,shoufei_bank,shoufei_account,shoufei_number,kaihuming,zhang_hao,kai_hu_hang,yue,is_kaili_fengxian,
  kaihuming_fengxian,zhang_hao_fengxian,kai_hu_hang_fengxian,yue_fengxian
) => qspost('/api/org/save_zijin', {
  zancun,is_kaili,shoufei_bank,shoufei_account,shoufei_number,kaihuming,zhang_hao,kai_hu_hang,yue,is_kaili_fengxian,
  kaihuming_fengxian,zhang_hao_fengxian,kai_hu_hang_fengxian,yue_fengxian
})

/*
* 闭店申请提交
* */
export const save_close = (close_file,close_doc) => qspost('/api/org/save_close', {
  close_file,close_doc
})

/*
* 闭店申请详情
* */
export const get_org_close = () => qspost('/api/org/get_org_close', {

})

/*
* 获取资金监管信息
* */
export const zijin = () => get('/api/org/zijin', {

})


/*
* 预收资金添加修改（每月10日之前）
* */
export const save_yushou = (id,yushou,file,type = '') => qspost('/api/org/save_yushou', {
  id,yushou,file,type
})

/*
* 预收资金列表
* */
export const yushou = (page,limit) => qspost('/api/org/yushou', {
  page,limit
})

/*
* 预收资金列表
* */
export const del_yushou = (id) => qspost('/api/org/del_yushou', {
  id
})

/*
* 机构运营 获取详情
* type : 1 党建信息2联系人信息3课程教材4教学开展5安全管理7行业促进
* */
export const get_yunying = (
  type
) => get(`/api/org/get_yunying?type=${type}`, {

})

/*
* 党的建设信息
* */
export const save_dangyuan = (
  zancun,dagnyuan_num,is_build_zuzhi,build_type,lishu_guanxi,lishu_guanxi_other,is_naru_zhangcheng,zhangcheng
) => qspost('/api/org/save_dangyuan', {
  zancun,dagnyuan_num,is_build_zuzhi,build_type,lishu_guanxi,lishu_guanxi_other,is_naru_zhangcheng,zhangcheng
})

/*
* 联系人信息
* */
export const save_contact = (
  zancun,faren_name,faren_idcard,faren_phone,fuzeren_name,fuzeren_idcard,fuzeren_phone,
  kongzhi_name,kongzhi_idcard,kongzhi_phone,gdList
) => qspost('/api/org/save_contact', {
  zancun,faren_name,faren_idcard,faren_phone,fuzeren_name,fuzeren_idcard,fuzeren_phone,
  kongzhi_name,kongzhi_idcard,kongzhi_phone,gdList
})
/*
* 联系人信息 股东
* */
export const save_gudong = (
  zancun,gdList
) => qspost('/api/org/gudong', {
  zancun,gdList
})

/*
* 课程教材信息保存
* */
export const save_classes = (
  zancun,peixun_lei,peixun_qita,ksList
) => qspost('/api/org/save_classes', {
  zancun,peixun_lei,peixun_qita,ksList
})

/*
* 课程教材信息保存教材
* */
export const save_jiaocai = (
  zancun,jcList
) => qspost('/api/org/save_jiaocai', {
  zancun,jcList
})

/*
* 获取月末学员情况详情
* */
export const get_xueyuan = (
  id
) => get(`/api/org/get_xueyuan?id=${id}`, {

})

/*
* 获取月末学员情况保存
* */
export const save_xueyuan = (
  student_num,money,file,class_num,id
) => qspost('/api/org/save_xueyuan', {
  student_num,money,file,class_num,id
})

/*
* 教学开展信息保存
* */
export const save_jiaoxue = (
  zancun,is_cansai,cansai_name,is_yanxue,quyu,qita_saishi_name
) => qspost('/api/org/save_jiaoxue', {
  zancun,is_cansai,cansai_name,is_yanxue,quyu,qita_saishi_name
})

/*
* 教学开展信息保存2
* */
export const save_jiaoxue2 = (
  zancun,total_ka_num,year_ka_num,ka_high_price,ka_lower_price
) => qspost('/api/org/save_jiaoxue2', {
  zancun,total_ka_num,year_ka_num,ka_high_price,ka_lower_price
})

/*
* 月末学员列表
* */
export const xueyuan_lst = (
  page,limit
) => qspost('/api/org/xueyuan_lst', {
  page,limit
})

/*
* 删除月末在册学员
* */
export const del_xueyuan = (
  id
) => qspost('/api/org/del_xueyuan', {
  id
})

/*
* 安全管理信息保存
* */
export const save_anquan = (
  zancun,is_qianan,is_zicha,last_yan_lian,zu_zhi,an_images
) => qspost('/api/org/save_anquan', {
  zancun,is_qianan,is_zicha,last_yan_lian,zu_zhi,an_images
})

/*
* 行业促进信息保存
* */
export const save_cujin = (
  zancun,huzhu,chengjie_lv,huodong_lv,zhengfu_rongyu
) => qspost('/api/org/save_cujin', {
  zancun,huzhu,chengjie_lv,huodong_lv,zhengfu_rongyu
})

/*
* 员工档案信息保存
* */
export const save_employ = (
  is_zancun,id,name,leixing,card_type,idcard,phone,have_zhengming,zhengming,pin_type,have_hetong,hetong,jiaoshi_zizhi
) => qspost('/api/org/save_employ', {
  is_zancun,id,name,leixing,card_type,idcard,phone,have_zhengming,zhengming,pin_type,have_hetong,hetong,jiaoshi_zizhi
})

/*
* 获取员工档案详情
* */
export const get_employ = (
  id
) => get(`/api/org/get_employ?id=${id}`, {

})

/*
* 员工档案列表
* */
export const employ_lst = (
  page,limit
) => qspost('/api/org/employ_lst', {
  page,limit
})

/*
* 删除员工
* */
export const del_employ = (
  id
) => qspost('/api/org/del_employ', {
  id
})


/*
* 监管信息添加
* */
export const save_jian = (
  id,do_date,jiancha_name,zijin_cunguan_is_gs,hetong_is_gs,price_is_gs,zhizhao_is_gs,jubaophone_is_gs,
  teachers_is_gs,tuifei_is_gs,anquan_is_hegui,anquan_wenti,anquan_is_zhenggai,yinhuan_is_exist,
  yinhuan,yinhuan_is_zhenggai,shigu_is_exist,shigu,xiaofang_dengji,other,is_zhenggai,zhenggai_time,
  zhenggai_content,zhenggai_file,is_wancheng_zhenggai,zhenggai_qing_file,is_yuetan,yuetan_time,yuetan_ren,
  yuetan_content,yuetan_file,leiji_tousu_year,leiji_tousu_month,leiji_tousu_wei,is_biangeng,biangeng_con,
  is_baingeng_beian,weibeian,tsList
) => qspost('/api/org/save_jian', {
  id,do_date,jiancha_name,zijin_cunguan_is_gs,hetong_is_gs,price_is_gs,zhizhao_is_gs,jubaophone_is_gs,
  teachers_is_gs,tuifei_is_gs,anquan_is_hegui,anquan_wenti,anquan_is_zhenggai,yinhuan_is_exist,
  yinhuan,yinhuan_is_zhenggai,shigu_is_exist,shigu,xiaofang_dengji,other,is_zhenggai,zhenggai_time,
  zhenggai_content,zhenggai_file,is_wancheng_zhenggai,zhenggai_qing_file,is_yuetan,yuetan_time,yuetan_ren,
  yuetan_content,yuetan_file,leiji_tousu_year,leiji_tousu_month,leiji_tousu_wei,is_biangeng,biangeng_con,
  is_baingeng_beian,weibeian,tsList
})

/*
* 监管信息详情
* */
export const get_jian = (
  id
) => get(`/api/org/get_jian?id=${id}`, {

})


/*
* 监管信息列表
* */
export const jian_lst = (
  page,limit
) => qspost('/api/org/jian_lst', {
  page,limit
})


/*
* 风险信息保存
* */
export const save_feng = (
  id,biangeng_con,is_jingying_yichang,jingying_yichang,is_shuiwu_yichang,shuiwu_yichang,shixin_con,
  laodong_jiufen,qianxian_jiufen,shebao_jiufen,fangzu_jiufen,is_zijin,zijin_qingkuang,is_zijin_dae,
  zijin_dae_qingkuang,is_yuqing,yuqing_qingkuang,weigui_con,is_shesu,shesu_con,is_zhongda_yinhuan,
  zhongda_yinhuan,other,is_zijinfengxian,zijin_jianguan_fengxian,pingtai_loubao,loubao_qingkuang,
  is_yishi,yishi_wenti
) => qspost('/api/org/save_feng', {
  id,biangeng_con,is_jingying_yichang,jingying_yichang,is_shuiwu_yichang,shuiwu_yichang,shixin_con,
  laodong_jiufen,qianxian_jiufen,shebao_jiufen,fangzu_jiufen,is_zijin,zijin_qingkuang,is_zijin_dae,
  zijin_dae_qingkuang,is_yuqing,yuqing_qingkuang,weigui_con,is_shesu,shesu_con,is_zhongda_yinhuan,
  zhongda_yinhuan,other,is_zijinfengxian,zijin_jianguan_fengxian,pingtai_loubao,loubao_qingkuang,
  is_yishi,yishi_wenti
})

/*
* 风险信息详情
* */
export const get_feng = (
  id
) => get(`/api/org/get_feng?id=${id}`, {

})

/*
* 风险信息列表
* */
export const feng_lst = (
  page,limit
) => qspost('/api/org/feng_lst', {
  page,limit
})

/*
 * 上传图片服务器
 * */
export const uploadFile = (url,params) => upload(url, params)

/*
* 风险预警统计
* */
export const statistics = () => get(`/api/org/warning/statistics`, {})

/*
* 风险预警列表/历史
* time 时间区间
* level 1灰色提示2黄色3橘色4红色
* status 4历史记录（已处理记录）
* */
export const warning_lst = (
  keyword,time,level,status,page,limit
) => qspost('/api/org/warning/lst', {
  keyword,time,level,status,page,limit
})

/*
* 风险预警上传资料/上传承诺书
* */
export const warning_upfile = (
  id,type,file
) => qspost('/api/org/warning/up_file', {
  id,type,file
})

/*
* 宣传列表
* */
export const promote_lst = (
  keword,time,page,limit
) => qspost('/api/org/promote/lst', {
  keword,time,page,limit
})

/*
* 宣传信息保存
* */
export const promote_save = (
  id,title,content,files
) => qspost('/api/org/promote/save', {
  id,title,content,files
})

/*
* 宣传信息详情
* */
export const get_promote = (
  id
) => get(`/api/org/promote/detail?id=${id}`, {

})

/*
* 宣传信息删除
* */
export const del_promote = (
  id
) => get(`/api/org/promote/del?id=${id}`, {

})

/*
* 星级评定列表
* */
export const star_lst = (
  keword,time,is_can,star,page,limit
) => qspost('/api/org/star/lst', {
  keword,time,is_can,star,page,limit
})

/*
* 宣传信息删除
* */
export const org_detail = (
  star_id
) => qspost(`/api/org/star/org_detail`, {
  star_id
})

/*
* 星级评定异议申诉
* */
export const star_shensu = (
  star_id,name,phone,content,files
) => qspost('/api/org/star/shensu', {
  star_id,name,phone,content,files
})

/*
* 星级评定异议申诉详情
* */
export const star_shensu_detail = (
  id
) => qspost(`/api/org/star/shen_detail`, {
  id
})

/*
* 星级评定异议申诉列表
* status = [ -1=>"已撤销", 0=>"待处理", 1=>"已受理", 2=>"已拒绝", 3=>"已完成" ];
* */
export const star_shensu_lst = (
  keyword,page,limit
) => qspost(`/api/org/star/shen_lst`, {
  keyword,page,limit
})

/*
* 星级评定异议申诉操作
* status -1撤销
* is_up   2上报
* */
export const star_shensu_set = (
  id,status,is_up
) => qspost(`/api/org/star/set_shen`, {
  id,status,is_up
})

/*
* 公众端首页
* */
export const masses_index = () => get(`/api/index`, {})

/*
* 公众端首页
* 参数 license  1持证机构 2非持证机构 3预警机构
* */
export const masses_star_lst = (license,page,limit) => qspost(`/api/star_lst`, {license,page,limit})


/*
* 公众端机构列表
* type = 1持证机构列表2开通监管账户机构
* */
export const masses_org_lst = (
  type,keyword,page,limit
) => qspost(`/api/org_lst`, {
  type,keyword,page,limit
})

/*
* 公众端文章列表
* type = 1政策法规3宣传信息
* */
export const masses_article_lst = (
  page,limit,type
) => qspost(`/api/lst/${type}`, {
  page,limit
})

/*
* 公众端文章文章详情
* */
export const masses_article_detail = (
  id
) => qspost(`/api/detail/${id}`, {
})

/*
* 星级评定报告参数
* */
export const star_baogao = (
  id
) => get(`/api/org/star/baogao?id=${id}`, {
})



/*
* 首页 机构
* */
export const org_index = (
) => get(`/api/org/index`, {
})

/*
* 读取信息 首页 机构
* */
export const read_index = (
  id
) => get(`/api/org/index/read?id=${id}`, {
})

/*
* 消息列表 首页 机构
* */
export const org_msglst = (
  page,limit
) => qspost('/api/org/index/msg', {
  page,limit
})

/*
* 问题反馈 首页 机构
* */
export const org_connect = (
  name,phone,content
) => qspost('/api/org/index/connect', {
  name,phone,content
})

/*
* 文章列表 首页 机构
* type 1政策法规2通知公告3宣传信息4下载中心
* */
export const org_indexlst = (
  keyword,page,limit,type
) => qspost(`/api/org/index/lst/${type}`, {
  keyword,page,limit
})

/*
* 文章详情 机构
* */
export const org_article_detail = (
  id
) => qspost(`/api/org/index/detail/${id}`, {
})

/*
* 修改密码
* */
export const edit_pass = (old_pass,new_pass) => qspost('/api/org/index/edit_pass', {
  old_pass,new_pass
})















































































































































































































































































































































































































































































































